import {getOnError} from '@freckle/educator-entities/ts/common/helpers/exception-handlers/bugsnag-helper/bugsnag-onerror'
import schoolBugsnagClient from '@freckle/school/ts/common/helpers/exception-handlers/bugsnag-client'

export function initializeGlobalEventListeners() {
  window.onerror = getOnError(schoolBugsnagClient)
}
